import {
  Component,
  OnInit,
  Input,
  SimpleChanges,
  AfterViewInit,
  OnChanges,
} from '@angular/core';
import { DatePipe } from '@angular/common';
import * as echarts from 'echarts';
import * as moment from 'moment';

@Component({
  selector: 'app-lms-chart',
  templateUrl: './lms-chart.component.html',
  styleUrls: ['./lms-chart.component.scss'],
})
export class LmsChartComponent implements OnInit,AfterViewInit,OnChanges {
  @Input() xAxisData: any;
  @Input() yAxisData: any;
  @Input() chartData: any;
  @Input() alarmData = [];
  @Input() inputMap=new Map()
  @Input() rangeValue:{minValue:number , maxValue: number}[];

  chartOption: any;
  options: any;
  alarmToolTip = null;

  constructor() { }

  ngOnInit(): void {
    this.loadChart(this.xAxisData,this.yAxisData,this.chartData,this.rangeValue,this.alarmData);
  }
  ngOnChanges(changes: SimpleChanges): void {
    // Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    // Add '${implements OnChanges}' to the class.
    this.loadChart(this.xAxisData,this.yAxisData,this.chartData,this.rangeValue,this.alarmData);
  }
  ngAfterViewInit(): void {
    // Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    // Add 'implements AfterViewInit' to the class.
    this.loadChart(this.xAxisData,this.yAxisData,this.chartData,this.rangeValue,this.alarmData);
  }

  loadChart(xaxis,yaxis,data,rangeValues,alarmData): void {
    // use loops to apply all the common options to X and Y axis
    if (yaxis.length === 0 || data.length === 0) {
      // chart can not be rendered if above info is not available
      return;
    }
    const legends = [];
    const yAxisOptions = [];
    const colors = [
      '#4F95D4',
      '#D53B8D',
      '#03B711',
      '#8D4DCD',
      '#F82C6A',
      '#0ADE89',
    ];
    const seriesData = [];

    let i=0;
    
    if (this.inputMap!=null && this.inputMap.size>=1) {
     
      this.inputMap.forEach((value,key)=>{
      
        if(this.rangeValue.length>=1 ){
        legends.push(key.legend);
        yAxisOptions.push(this.generateYAxis(i,colors,key,value.minValue,value.maxValue));
        seriesData.push(this.generateseriesData(i,key,data,colors,alarmData));
        i=i+1;
        }
      
    });

     if(this.inputMap.size!=0 && this.inputMap.size<yaxis.length){ 
      yaxis.forEach((y,index) => {
        if(index>=i){
     legends.push(y.legend);
         yAxisOptions.push(this.generateYAxisOption(index,colors,y));
         seriesData.push(this.generateseriesData(index,y,data,colors,alarmData));
         rangeValues=[];
    }})
     }
    }
    
    else {
      yaxis.forEach((y,index) => {
        legends.push(y.legend);
        yAxisOptions.push(this.generateYAxisOption(index,colors,y));
        seriesData.push(this.generateseriesData(index,y,data,colors,alarmData));
        rangeValues=[];
      });
    }
  
    this.chartOption = this.getChartOptions(
      colors,
      legends,
      xaxis,
      yAxisOptions,
      seriesData
    );
  }


  generateYAxisOption(index,colors,y): any {
    const unit = y.unit;
    const yAxisPosition = index % 2 !== 0 ? 'right' : 'left';
    const yAxisColor = colors[index];
    const nameTextPadding =
      yAxisPosition === 'left' ? [0,0,50,15] : [0,15,50,0]; // [top, right, bottom, left]
    const yOffset = Math.floor(index / 2) * 40;
    return {
      type: 'value',
      name: unit,
      nameTextStyle: {
        fontSize: 10,
        padding: nameTextPadding,
        color: '#B5B5B5',
        align: yAxisPosition,
      },
      nameLocation: 'start',
      nameRotate: yAxisPosition === 'left' ? '90' : '270',
      //min and max value for y axis data.
      min: function (value) {
        return value.min;
      },

      max: function (value) {
        return value.max;
      },
      position: yAxisPosition,
      offset: yOffset,
      axisLine: {
        lineStyle: {
          color: yAxisColor,
        },
      },
      axisTick: { show: false },
      axisLabel: {
        formatter: '{value}',
        fontSize: 10,
        color: '#6e6e6e',
      },
      splitLine: {
        show: true,
        lineStyle: { type: 'dashed',color: '#6e6e6e',opacity: 0.25 },
      },
    };
  }
  generateYAxis(index,colors,y,minValue,maxValue): any {
    const unit = y.unit;
    const yAxisPosition = index % 2 !== 0 ? 'right' : 'left';
    const yAxisColor = colors[index];
    const nameTextPadding =
      yAxisPosition === 'left' ? [0,0,50,15] : [0,15,50,0]; // [top, right, bottom, left]
    const yOffset = Math.floor(index / 2) * 40;
    return {
      type: 'value',
      name: unit,
      nameTextStyle: {
        fontSize: 10,
        padding: nameTextPadding,
        color: '#B5B5B5',
        align: yAxisPosition,
      },
      nameLocation: 'start',
      nameRotate: yAxisPosition === 'left' ? '90' : '270',
      //min and max value for y axis data.
      min: function () {
        return minValue;
      },

      max: function () {
        return maxValue;
      },
      position: yAxisPosition,
      offset: yOffset,
      axisLine: {
        lineStyle: {
          color: yAxisColor,
        },
      },
      axisTick: { show: false },
      axisLabel: {
        formatter: '{value}',
        fontSize: 10,
        color: '#6e6e6e',
      },
      splitLine: {
        show: true,
        lineStyle: { type: 'dashed',color: '#6e6e6e',opacity: 0.25 },
      },
    };
  }
  generateseriesData(index,y,data,colors,alarmData): any {
    return {
      name: y.legend,
      type: 'line',
      smooth: y.smooth,
      yAxisIndex: index,
      data: data[index],
      markPoint: this.generateAlertPoints(y,data[index],alarmData),
      color: colors[index],
      connectNulls: true,
    };
  }

  generateAlertPoints(type,chartData,alarmData) {
    let symbol = "path://m797.94 212.01l-25.607-48c-.736-1.333-2.068-2.074-3.551-2.074-1.483 0-2.822.889-3.569 2.222l-25.417 48c-.598 1.185-.605 2.815.132 4 .737 1.185 1.921 1.778 3.404 1.778h51.02c1.483 0 2.821-.741 3.42-1.926.747-1.185.753-2.667.165-4";
    let dataValue = [];
    let color = "";
    let duplicateAlarms="";
  

    for (var index in chartData) {
     
      for (var index1 in alarmData) {
        const isoStr = new Date(alarmData[index1].createdOn).toISOString().substring(0,19) + "Z";
        let mixedDataItem = alarmData[index1].dataItem.split(",").map(function (item) {
          return item.trim();
        });
        color = (alarmData[index1].currentState == "Close") ? "Yellow" : "Red";
        let mixedDataItemValue = alarmData[index1].dataItemValue.split(",");
        if (mixedDataItem.includes(type.legend)) {
          let myIndex = mixedDataItem.indexOf(type.legend);
        
          if (chartData[index][1] == mixedDataItemValue[myIndex] && isoStr==chartData[index][0]) {
       
           let dup=dataValue.find(x => (x.xAxis==chartData[index][0]));
  
           if(dup!=undefined){

            const idx = dataValue.findIndex(x => (x.xAxis===chartData[index][0]));
            duplicateAlarms+=dup.name+",";
            dataValue.splice(idx,1);  
           }
         dataValue.push(
              {
                name: duplicateAlarms+alarmData[index1].name,
                symbolSize: 10,
                symbol: symbol,
                xAxis: chartData[index][0],
                yAxis: chartData[index][1],
                itemStyle: {
                  color: color
                },
              }
            );
            duplicateAlarms="";
          }
        }
      };


    }
    return {
      tooltip: {
        trigger: 'item',
        axisPointer: { type: 'cross' }
      },data: dataValue
    };
  }

  getChartOptions(colors,legends,xaxis,yaxis,seriesData): any {

    return {
      color: colors,
      height: '65%',
      tooltip: {
        trigger: 'axis',
      
        formatter: this.formatTooltip,
      },
      legend: {
        top: '10px',
        width: 'auto',
        height: '25px',
        itemGap: 20,
        textStyle: {
          color: '#6e6e6e',
          fontSize: '10',
          fontWeight: 'bold',
          align: 'left',
          padding: [3,0,0,-10],
        },
        data: legends,
        icon: 'square',
      },
      xAxis: [
        {
          type: 'time',
          name: 'Duration',
          nameLocation: 'center',
          data: xaxis,
          nameTextStyle: {
            padding: [30,0,0,0],
            fontSize: 10,
            color: '#6e6e6e',
            fontWeight: 'bold',
          },
          axisLabel: {
            formatter:axisValue => {
              return moment.utc(axisValue).format("DD/MM/YYYY")+"\n"+moment.utc(axisValue).format("hh:mm A");
            },
            fontSize: 12,
            fontWeight: 'light',
            color: '#6e6e6e',
            lineHeight: 15,
          },
          splitLine: { show: false },
          axisLine: {
            lineStyle: {
              type: 'solid',
              opacity: 1,
              color: '#6e6e6e',
            },
          },
          triggerEvent: true,
        },
      ],
      yAxis: yaxis,
      series: seriesData,
    };
  }


  formatTooltip(params): any {
    const datePipe = new DatePipe('en-US');
    if (params[0] != undefined) {

      const timeStamp = new Date(params[0].value[0]);
      const chartdate=  moment.utc(timeStamp).format("DD/MM/YYYY hh:mm A")
      
      let output = `<b>${chartdate}</b><br/>`;


      for (let i = 0; i < params.length; i++) {
        output += `${params[i].marker}${params[i].seriesName} : ${params[i].value[1]}`;

        if (i !== params.length - 1) {
          output += '<br/>';
        }
      }

      return output;
    }
    else {
      let alarmsVal=params.name.split(",");
      const timeStamp = new Date(params.data.xAxis);
      const chartdate=  moment.utc(timeStamp).format("DD/MM/YYYY hh:mm A")
      let output = `<b>${chartdate}</b><br/>`;

      alarmsVal.forEach((x,i)=>{
       
        output += `<b style="color:red">Alarm:</b> ` + x;
   
        output += '<br/>';
      })
     
      return output;
    }

  }
}